import { render, staticRenderFns } from "./CityTaxiPricing.vue?vue&type=template&id=12cc499a"
import script from "./CityTaxiPricing.vue?vue&type=script&lang=js"
export * from "./CityTaxiPricing.vue?vue&type=script&lang=js"
import style0 from "./CityTaxiPricing.vue?vue&type=style&index=0&id=12cc499a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports